import { useMutation } from '@tanstack/react-query';

import { calendarApi } from '../api';

interface UseSubscribeGoogleCalendarWatchParams {
  calendarIds: string[];
  userId: string;
}

export function useSubscribeGoogleCalendarWatch() {
  const subscribeGoogleWatchMutation = useMutation({
    mutationFn: ({ calendarIds, userId }: UseSubscribeGoogleCalendarWatchParams) => {
      return calendarApi.subscribeGoogleCalendarWatch({ calendarIds, userId });
    },
  });

  return {
    subscribeGoogleCalendarWatch: subscribeGoogleWatchMutation.mutateAsync,
    ...subscribeGoogleWatchMutation,
  };
}
